import { guideReaderParams } from './guidePractice.js';

// URL selection is a pointer, never an access grant. The caller supplies ONLY
// the same already-visible free/paid text list used by the sidebar.
export function setTextLocation(texts, requestedId, { freeLoading = false, paidState } = {}) {
    const match = texts.find(text => text.id === requestedId);
    const selected = match || texts[0] || null;
    // A paid deep link can arrive before entitlement/items. Keep the URL intact
    // and don't let its temporary free fallback overwrite Library Resume.
    // A failed paid read also cannot establish that the requested ID is invalid.
    const unresolved = ['resolving', 'loading', 'error'].includes(paidState);
    const remember = !!selected && !freeLoading && (!!match || !unresolved);
    return { selected, remember };
}

export function setTextSelectionParams(current, itemId, texts, patch = {}) {
    if (!texts.some(text => text.id === itemId)) return null;
    // One navigation per action: a practice-filter change must not race a second
    // query update and lose either item or quizGuide. Other query values survive.
    return guideReaderParams(current, { ...patch, item: itemId });
}
